export const DEFAULT_FORM_DATA = {
  choice_set: "",
  default: null,
  description: "",
  is_required: false,
  is_unique: false,
  label: "",
  name: "",
  object_types: [],
  related_object_type: "",
  type: "",
};
